import { AfterViewInit, Component, OnInit } from '@angular/core';
declare var iniciar: Function;

@Component({
  selector: 'app-base-layout',
  template: '',
  styles: [],
})
export class BaseLayoutComponent implements AfterViewInit {
  constructor() {}

  ngAfterViewInit(): void {
    iniciar();
  }
}
